{
  "actionbar.actions": "Ações",
  "actionbar.actionsAvailable": "Ações disponíveis.",
  "actionbar.clearSelection": "Limpar seleção",
  "actionbar.selected": "{count, plural, =0 {Nenhum selecionado} one {# selecionado} other {# selecionados}}",
  "actionbar.selectedAll": "Tudo selecionado",
  "breadcrumbs.more": "Mais artigos",
  "button.pending": "pendente",
  "calendar.invalidSelection": "A(s) {selectedCount, plural, one {data} other {datas}} selecionada(s) não está(ão) disponível/disponível(eis).",
  "combobox.noResults": "Sem resultados",
  "contextualhelp.help": "Ajuda",
  "contextualhelp.info": "Informação",
  "datepicker.endTime": "Terminar tempo",
  "datepicker.startTime": "Iniciar tempo",
  "datepicker.time": "Tempo",
  "dialog.alert": "Alerta",
  "dialog.dismiss": "Dispensar",
  "dropzone.replaceMessage": "Largar ficheiro para substituir",
  "inlinealert.informative": "Informação",
  "inlinealert.negative": "Erro",
  "inlinealert.notice": "Aviso",
  "inlinealert.positive": "Sucesso",
  "label.(optional)": "(opcional)",
  "label.(required)": "(obrigatório)",
  "menu.moreActions": "Mais ações",
  "notificationbadge.indicatorOnly": "Nova atividade",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Selecionar…",
  "slider.maximum": "Máximo",
  "slider.minimum": "Mínimo",
  "table.loading": "A carregar...",
  "table.loadingMore": "A carregar mais...",
  "table.resizeColumn": "Redimensionar coluna",
  "table.sortAscending": "Ordenar por ordem ascendente",
  "table.sortDescending": "Ordenar por ordem decrescente",
  "tag.actions": "Ações",
  "tag.hideButtonLabel": "Mostrar menos",
  "tag.noTags": "Nenhum",
  "tag.showAllButtonLabel": "Mostrar tudo ({tagCount, number})",
  "toast.clearAll": "Limpar tudo",
  "toast.collapse": "Colapsar",
  "toast.showAll": "Mostrar tudo"
}
